import axios from 'axios';
import { getCachedJWTToken } from '../services/jwtTokenService';
import { logError } from '../utils/logger';

/**
 * Setup axios interceptor to automatically add JWT token and API key to requests
 * This interceptor adds the JWT token and x-api-key to all axios requests if available
 */
export const setupAxiosInterceptor = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = getCachedJWTToken();

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        logError('[Axios Interceptor] Unauthorized request - JWT may be expired');
      }
      return Promise.reject(error);
    }
  );
};
